import React, { forwardRef, memo } from 'react';
import PropTypes from 'prop-types';
import { Notification } from '@snsw/react-component-library';

const ErrorSummary = forwardRef(({ errors, title, headingTemplate, minErrors }, ref) => {
    const errorsLength = errors ? Object.keys(errors).length : 0;
    const lengthStr = errorsLength > 1 ? errorsLength : '';
    const keys = errorsLength ? Object.keys(errors) : [];

    // Keys may be a path (e.g. businessDisaster.business.abn) or not (e.g., eligibilityCheck)
    //   but for convenience's sake, the node's ID will just be the last part (e.g., 'abn')
    //   Assumption: IDs are unique!
    const getNodeId = key => {
        if (key.includes('.')) { return key.split('.').at(-1); }
        else { return key; }
    };

    return errorsLength < (minErrors ?? 1) ? null : (
        <div ref={ ref } className='alert'>
            <Notification
                variant='error'
                title={ title }
                role='alert'
                className='alert'
            >
                <p>{headingTemplate.replace('%s', lengthStr)}</p>
                {errorsLength > 1 &&
                    <ol>{keys.map(key =>
                        <li key={ key }>
                            <a
                                href={ `#${key}` }
                                onClick={
                                    e => {
                                        e.preventDefault();
                                        const nodeId = getNodeId(key);
                                        const inputs = document.querySelectorAll(
                                            `[name*="${nodeId}"],[id*="${nodeId}"]`
                                        );

                                        // Find the first focusable input
                                        for (const input of inputs) {
                                            input.focus();
                                            if (document.activeElement === input) {
                                                break;
                                            }
                                        }
                                    }
                                }
                            >
                                {errors[key].message}
                            </a>
                        </li>
                    )}
                    </ol>}
                {errorsLength === 1 && errors[keys[0]].message}
            </Notification>
        </div>
    );
});

ErrorSummary.displayName = 'ErrorSummary';

ErrorSummary.propTypes = {
    errors: PropTypes.object.isRequired,
    title: PropTypes.string,
    headingTemplate: PropTypes.string,
    minErrors: PropTypes.number
};

ErrorSummary.defaultProps = {
    title: 'Your form has errors',
    headingTemplate: 'Check the following %s errors:',
    minErrors: 1
};

export default memo(ErrorSummary);
